var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorsearchlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 -1 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 14.6673L13.3335 13.334M7.66683 14.0007C8.49853 14.0007 9.3221 13.8368 10.0905 13.5186C10.8589 13.2003 11.5571 12.7338 12.1452 12.1457C12.7333 11.5576 13.1998 10.8594 13.5181 10.091C13.8363 9.32258 14.0002 8.49902 14.0002 7.66732C14.0002 6.83561 13.8363 6.01205 13.5181 5.24366C13.1998 4.47526 12.7333 3.77708 12.1452 3.18897C11.5571 2.60087 10.8589 2.13436 10.0905 1.81608C9.3221 1.4978 8.49853 1.33398 7.66683 1.33398C5.98713 1.33398 4.37622 2.00124 3.18849 3.18897C2.00076 4.37671 1.3335 5.98761 1.3335 7.66732C1.3335 9.34702 2.00076 10.9579 3.18849 12.1457C4.37622 13.3334 5.98713 14.0007 7.66683 14.0007Z",
    stroke: "#8C8C8C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorsearchlogo);
export default __webpack_public_path__ + "static/media/Vectorsearchlogo.da17ab87715ae5d18d13cdf5257333e2.svg";
export { ForwardRef as ReactComponent };